import React from 'react'
import * as THREE from "three"
import { useTexture } from '@react-three/drei'
import { useSelector } from 'react-redux';
import { E_MainLato, E_GenereOmbrellone } from "../Utils/enumerations";

// Genera la rampa disabili
export default function Rampa() {
    const lunghezzaPedana = useSelector(state => state.uiMainMenu.lunghezza);   
    const larghezzaPedana = useSelector(state => state.uiMainMenu.larghezza); 
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza);
    const latoIngresso = useSelector(state => state.uiMainMenu.ingresso);
    const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
    const ombrelloniIsVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
    const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);

    let offsetPedanaLato = 0;
     
    const depth = 1, width = 1, height = 1;
    const pedanaOffset = 0.1;
    let pos = [0,0,0];
    let rot = [0,0,0];
    const shape = new THREE.Shape();  

    const extrudeSettings = {
        steps: 2,
        depth: depth,
        bevelEnabled: true,
        bevelThickness: 0.005,
        bevelSize: 0.005,
        bevelOffset: -0.003,
        bevelSegments: 5,
    }; 

    // Calcola la forma e la posizione della rampa disabili a seconda della configurazione scelta
    if (latoIngresso === E_MainLato.Lato1.toString()) {  
        // Offset
        if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && larghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = -larghezzaPedana/2 + dataOmbrelloni[0].secondaryDimension/2;
        } else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && larghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = larghezzaPedana/2 - dataOmbrelloni[0].secondaryDimension/2;
        } else {
            offsetPedanaLato = 0;
        }  
        shape.moveTo(-lunghezzaPedana / 2 + depth, 0);
        shape.lineTo(-lunghezzaPedana / 2  + pedanaOffset, 0);
        shape.lineTo(-lunghezzaPedana / 2  + pedanaOffset, 0.0025);
        shape.lineTo(-lunghezzaPedana / 2 + depth, altezzaPedana * 1);
        shape.lineTo(-lunghezzaPedana / 2  + depth, 0);   
        pos = [0,0,-width/2 + offsetPedanaLato]        
    }
    else if (latoIngresso === E_MainLato.Lato2.toString()) {
        // Offset
        if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && lunghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = -lunghezzaPedana/2 + dataOmbrelloni[0].secondaryDimension/2;
        } else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && lunghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = lunghezzaPedana/2 - dataOmbrelloni[0].secondaryDimension/2;
        } else {
            offsetPedanaLato = 0;
        }  
        shape.moveTo(larghezzaPedana / 2 - depth, 0);
        shape.lineTo(larghezzaPedana / 2 - pedanaOffset, 0);
        shape.lineTo(larghezzaPedana / 2 - pedanaOffset, 0.0025);
        shape.lineTo(larghezzaPedana / 2 - depth, altezzaPedana * 1);
        shape.lineTo(larghezzaPedana / 2 - depth, 0);   
        pos = [-width/2 + offsetPedanaLato,0,0]  
        rot = [0,Math.PI/2,0] 
    }
    else if (latoIngresso === E_MainLato.Lato3.toString()) {
        // Offset
        if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato2.toString() && larghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = -larghezzaPedana/2 + dataOmbrelloni[0].secondaryDimension/2;
        } else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato4.toString() && larghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = larghezzaPedana/2 - dataOmbrelloni[0].secondaryDimension/2;
        } else {
            offsetPedanaLato = 0;
        }      
        shape.moveTo(lunghezzaPedana / 2 - depth, 0);
        shape.lineTo(lunghezzaPedana / 2 - pedanaOffset, 0);
        shape.lineTo(lunghezzaPedana / 2 - pedanaOffset, 0.0025);
        shape.lineTo(lunghezzaPedana / 2 - depth, altezzaPedana * 1);
        shape.lineTo(lunghezzaPedana / 2 - depth, 0);   
        pos = [0,0,-width/2 + offsetPedanaLato]        
    }
    else if (latoIngresso === E_MainLato.Lato4.toString()) {
        // Offset
        if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato1.toString() && lunghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = -lunghezzaPedana/2 + dataOmbrelloni[0].secondaryDimension/2;
        } else if (ombrelloniIsVisible && dataOmbrelloni.length > 0 &&
            (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString()) &&
            latoOmbrelloni.toString() === E_MainLato.Lato3.toString() && lunghezzaPedana > dataOmbrelloni[0].secondaryDimension) {
                offsetPedanaLato = lunghezzaPedana/2 - dataOmbrelloni[0].secondaryDimension/2;
        } else {
            offsetPedanaLato = 0;
        }      
        shape.moveTo(-larghezzaPedana / 2 + depth, 0);
        shape.lineTo(-larghezzaPedana / 2 + pedanaOffset, 0);
        shape.lineTo(-larghezzaPedana / 2 + pedanaOffset, 0.0025);
        shape.lineTo(-larghezzaPedana / 2 + depth, altezzaPedana * 1);
        shape.lineTo(-larghezzaPedana / 2 + depth, 0);   
        pos = [-width/2 + offsetPedanaLato,0,0]  
        rot = [0,Math.PI/2,0] 
    }

    const rampaTexturesProps = useTexture({
        map: `${process.env.PUBLIC_URL}/textures/rampa/rampa_basecolor.jpg`,
        normalMap: `${process.env.PUBLIC_URL}/textures/rampa/rampa_normal.jpg`,
        roughnessMap: `${process.env.PUBLIC_URL}/textures/rampa/rampa_roughness.jpg`,
        aoMap: `${process.env.PUBLIC_URL}/textures/rampa/rampa_ambientOcclusion.jpg`,
    })

    rampaTexturesProps.map.repeat.set(width, height);
    rampaTexturesProps.normalMap.repeat.set(width, height);
    rampaTexturesProps.roughnessMap.repeat.set(width, height);
    rampaTexturesProps.aoMap.repeat.set(width, height);

    rampaTexturesProps.map.wrapS = rampaTexturesProps.map.wrapT = THREE.RepeatWrapping;
    rampaTexturesProps.normalMap.wrapS = rampaTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
    rampaTexturesProps.roughnessMap.wrapS = rampaTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
    rampaTexturesProps.aoMap.wrapS = rampaTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;

    rampaTexturesProps.map.rotation = Math.PI / 2;
    rampaTexturesProps.normalMap.rotation = Math.PI / 2;
    rampaTexturesProps.roughnessMap.rotation = Math.PI / 2;
    rampaTexturesProps.aoMap.rotation = Math.PI / 2;

    return (
        <mesh position={pos} rotation={rot}>
            <extrudeGeometry args={[shape, extrudeSettings]} />
            <meshStandardMaterial {...rampaTexturesProps} />
        </mesh>
    )
}
